module.exports = __webpack_public_path__ + "img/2012-09-06 (FF 02) Montage Holzelemente.7a1e3b3c.jpg";